/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Image from "gatsby-image"
import Social from './social';

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fixed(width: 150, height: 150) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  const { author, social } = data.site.siteMetadata
  return (
    <div>
    <div className='bio-container'>
      <div className='bio-image'>
        <Image
          fixed={data.avatar.childImageSharp.fixed}
          alt={author.name}
        />
      </div>
      <p>
        My name is <b>Lenvin Gonsalves</b>. I'm a Software Engineer building production AI systems.
        <br /><br />
        Currently at <a href='https://joinfleek.com/'>Fleek</a> (YC W22), where I design and ship multi-agent AI pipelines, internal developer platforms, and full-stack product features across web, mobile, and serverless infrastructure.
        <br /><br />
        Previously at <a href='https://oozou.com/'>OOZOU</a> (Bangkok), where I was one of the first engineers on <a href='https://www.makro.pro/en'>Makro Pro</a> — now Thailand's #1 grocery e-commerce platform with $300M+ GMV/year. And before that at OYKU, a no-code platform for creators where I built the <b>Wild Planet</b> Alexa skill, which hit 43,000+ daily requests in India.
        <br /><br />
        I've contributed to <a href='https://github.com/nodejs/node'>Node.js core</a>, published open-source Gatsby plugins, and written about systems I've built from the ground up. <Link to='/landing'>More about me &rarr;</Link>
        <br /><br />
        <b>Some posts I've written are below.</b> I occasionally publish them at <a href='https://dev.to/98lenvi'>Dev.to</a> as well.
      </p>
    </div>

    </div>
  )
}

export default Bio
